// /academy/psicologia — Psychology of trading module.
// Lists 3 long-form lessons; each links to /academy/psicologia/:id.
import React from "react";
import { Link } from "react-router-dom";
import { Brain, Clock } from "lucide-react";
import AcademyShell from "../components/academy/AcademyShell";
import { useLanguage } from "../i18n/LanguageContext";
import { getAcademyToolsI18n } from "../i18n/academy-tools";
import { getLeccionesPsicologia } from "../data/i18n-academy";

const AcademyPsicologiaPage = () => {
  const { lang } = useLanguage();
  const T = getAcademyToolsI18n(lang);
  const LECCIONES_PSICOLOGIA = getLeccionesPsicologia(lang);
  return (
  <AcademyShell
    testid="academy-psicologia"
    eyebrow={`${T.psi_eyebrow_prefix} ${LECCIONES_PSICOLOGIA.length} ${T.psi_lessons}`}
    eyebrowIcon={Brain}
    title={T.psi_title}
    subtitle={T.psi_subtitle}
    breadcrumbCurrent={T.psi_breadcrumb}
    footHint={T.psi_foot}
  >
    <div className="grid gap-4 lg:grid-cols-2" data-testid="psi-list">
      {LECCIONES_PSICOLOGIA.map((l) => (
        <Link
          key={l.id}
          to={`/academy/psicologia/${l.id}`}
          data-testid={`psi-card-${l.id}`}
          className="group rounded-xl border border-white/10 bg-white/[0.03] p-5 transition-all hover:border-orange-400/40 hover:bg-orange-400/[0.04]"
        >
          <div className="mb-2 flex items-center gap-2 text-[10px] font-bold uppercase tracking-[0.22em] text-white/45">
            <span className="rounded-full border border-orange-400/40 bg-orange-400/[0.08] px-2 py-0.5 text-orange-200">
              {T.psi_lesson} {l.numero}
            </span>
            <span className="inline-flex items-center gap-1">
              <Clock className="h-3 w-3" />
              {l.duracion}
            </span>
          </div>
          <h3 className="font-display text-lg font-black leading-tight text-white">
            {l.titulo}
          </h3>
          <p className="mt-2 text-[12px] text-white/55">{l.descripcion}</p>
          <span className="mt-3 inline-block text-[10px] font-bold uppercase tracking-[0.22em] text-orange-300 opacity-0 transition-opacity group-hover:opacity-100">
            {T.psi_read}
          </span>
        </Link>
      ))}
    </div>
  </AcademyShell>
  );
};

export default AcademyPsicologiaPage;
